<template>
  <div>
    <div id="content" v-html="html"></div>
  </div>
</template>

<script>
import MentHmtl from './language';

export default {
  name: 'Privacy',
  data() {
    return {
      html: MentHmtl,
    };
  },
};
</script>

<style scoped>
#cover {
  width: 100%;
}

#content {
  box-sizing: border-box !important;
  text-align: justify !important;
  max-width: 1024px;
}

#content >>> img {
  display: block;
  width: 95% !important;
  max-width: 100% !important;
  height: auto !important;
  padding: 0 !important;
  margin: 0 auto !important;
}

#content >>> * {
  max-width: 100% !important;
  word-break: break-all;
  box-sizing: border-box !important;
}

#content >>> video {
  max-width: 100% !important;
  word-break: break-all;
  pointer-events: all !important;
  box-sizing: border-box !important;
}

#content >>> a {
  text-decoration: none !important;
}

#content >>> ul {
  max-width: 100% !important;
  margin-left: 0 !important;
  list-style-position: initial !important;
  padding: 0 15px !important;
  box-sizing: border-box !important;
}

#content >>> p {
  max-width: 100% !important;
  line-height: 1.75 !important;
  box-sizing: border-box !important;
}

#content >>> li {
  max-width: 100% !important;
  margin: 5px 0 !important;
  box-sizing: border-box !important;
}
</style>
